'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isBatchHomepageLoaded = isBatchHomepageLoaded;
exports.isLoaded = isLoaded;
exports.isSeoLoaded = isSeoLoaded;
exports.loadCat = loadCat;
exports.loadSeo = loadSeo;
exports.loadBanner = loadBanner;
exports.loadCatServer = loadCatServer;
exports.handleMainCat = handleMainCat;
exports.handleSubCat = handleSubCat;
exports.changeHeader = changeHeader;
exports.setPathName = setPathName;
exports.loadDynamicLink = loadDynamicLink;
exports.batchHomepage = batchHomepage;
exports.setCat = setCat;
exports.showDownloadAppPopup = showDownloadAppPopup;
exports.hideDownloadAppPopup = hideDownloadAppPopup;

var _ApiClient = require('helpers/ApiClient');

var _seo = require('redux/stateDefault/seo');

var _seo2 = _interopRequireDefault(_seo);

var _lib = require('helpers/lib');

var _support = require('helpers/support');

var _ApiServer = require('helpers/ApiServer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_CAT = 'lookme/setup/LOAD_CAT';
var LOAD_CAT_SUCCESS = 'lookme/setup/LOAD_CAT_SUCCESS';
var LOAD_CAT_FAIL = 'lookme/setup/LOAD_CAT_FAIL';
var LOAD_SEO = 'lookme/setup/LOAD_SEO';
var LOAD_SEO_SUCCESS = 'lookme/setup/LOAD_SEO_SUCCESS';
var LOAD_SEO_FAIL = 'lookme/setup/LOAD_SEO_FAIL';
var CHANGE_MAIN_CAT = 'lookme/setup/CHANGE_MAIN_CAT';
var CHANGE_SUB_CAT = 'lookme/setup/CHANGE_SUB_CAT';
var CHANGE_HEADER = 'lookme/setup/CHANGE_HEADER';
var SET_REDIRECT_LOGIN = 'lookme/setup/SET_REDIRECT_LOGIN';
var LOAD_DYNAMIC = 'lookme/setup/LOAD_DYNAMIC';
var LOAD_DYNAMIC_SUCCESS = 'lookme/setup/LOAD_DYNAMIC_SUCCESS';
var LOAD_DYNAMIC_FAIL = 'lookme/setup/LOAD_DYNAMIC_FAIL';
var SET_CATEGORY = 'lookme/setup/SET_CATEGORY';
var BATCH_HOMEPAGE = 'lookme/setup/BATCH_HOMEPAGE';
var BATCH_HOMEPAGE_SUCCESS = 'lookme/setup/BATCH_HOMEPAGE_SUCCESS';
var BATCH_HOMEPAGE_FAIL = 'lookme/setup/BATCH_HOMEPAGE_FAIL';

var PROMINENT = 'lookme/shops/PROMINENT';
var PROMINENT_SUCCESS = 'lookme/shops/PROMINENT_SUCCESS';
var PROMINENT_FAIL = 'lookme/shops/PROMINENT_FAIL';

var FEATURED = 'lookme/shops/FEATURED';
var FEATURED_SUCCESS = 'lookme/shops/FEATURED_SUCCESS';
var FEATURED_FAIL = 'lookme/shops/FEATURED_FAIL';

var SUGGEST = 'lookme/shops/SUGGEST';
var SUGGEST_SUCCESS = 'lookme/shops/SUGGEST_SUCCESS';
var SUGGEST_FAIL = 'lookme/shops/SUGGEST_FAIL';

var COLLECTION = 'lookme/collections/LOAD';
var COLLECTION_SUCCESS = 'lookme/collections/LOAD_SUCCESS';
var COLLECTION_FAIL = 'lookme/collections/LOAD_FAIL';

var GET_ALL_REWARD = 'lookme/voucher/GET_ALL_REWARD';
var GET_ALL_REWARD_FAIL = 'lookme/voucher/GET_ALL_REWARD_FAIL';
var GET_ALL_REWARD_SUCCESS = 'lookme/voucher/GET_ALL_REWARD_SUCCESS';

var LOAD_BANNER = 'lookme/setup/LOAD_BANNER';
var LOAD_BANNER_SUCCESS = 'lookme/setup/LOAD_BANNER_SUCCESS';
var LOAD_BANNER_FAIL = 'lookme/setup/LOAD_BANNER_FAIL';

var SHOW_DOWNLOAD_APP_POPUP = 'lookme/setup/SHOW_DOWNLOAD_APP_POPUP';
var HIDE_DOWNLOAD_APP_POPUP = 'lookme/setup/HIDE_DOWNLOAD_APP_POPUP';

var initialState = {
  loaded: false,
  seoLoaded: false,
  categories: null,
  suggests: [{ label: 'Gần tôi', code: 'nearby' }, { label: 'Nổi bật', code: 'prominent' }, { label: 'Gợi ý', code: 'suggest' }],
  seos: (0, _lib.arr2Obj)(_seo2.default, 'link'),
  categoriesFilter: {},
  subCatFilter: {},
  header: {},
  configHeader: null,
  appLink: null,
  cat: 'cham-soc-da-massage',
  pathSeo: '/',
  dynamicLinkBanner: null,
  batchHomepage: {
    loaded: false,
    loading: true,
    data: [],
    fail: false
  },
  popupDownloadAppDisplayed: false
};
function initCategoryFilter(categories) {
  var categoriesFilter = {};
  if (categories && categories.length > 0) {
    for (var index = 0; index < categories.length; index++) {
      categoriesFilter[categories[index].code] = 'none'; // all, notAll, none
    }
  }
  return categoriesFilter;
}
function initSubCatFilter(categories) {
  var subCatFilter = {};
  if (categories && categories.length > 0) {
    for (var index = 0; index < categories.length; index++) {
      subCatFilter[categories[index].code] = []; // all, not-all, none
    }
  }
  return subCatFilter;
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_CAT:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_CAT_SUCCESS:
      {
        // console.log({ categories: action.result });
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: true,
          categories: [].concat((0, _toConsumableArray3.default)(action.result)).sort(function (one, two) {
            one.order - two.order;
          }),
          categoriesFilter: initCategoryFilter(action.result),
          subCatFilter: initSubCatFilter(action.result)
        });
      }
    case LOAD_CAT_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: false,
          error: action.error
        });
      }
    case LOAD_SEO:
      return (0, _extends3.default)({}, state, {
        seoLoading: true,
        pathSeo: action.pathSeo
      });
    case LOAD_SEO_SUCCESS:
      return (0, _extends3.default)({}, state, {
        seoLoading: false,
        seoLoaded: true,
        seos: (0, _lib.arr2Obj)(action.payload.data, 'link')
      });
    case LOAD_SEO_FAIL:
      return (0, _extends3.default)({}, state, {
        seoLoading: false,
        seoLoaded: false,
        seoError: action.error
      });
    case LOAD_BANNER:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_BANNER_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: true,
          banners: action.result
        });
      }
    case LOAD_BANNER_FAIL:
      {
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: false,
          error: action.error
        });
      }
    case CHANGE_MAIN_CAT:
      return (0, _extends3.default)({}, state, {
        categoriesFilter: action.categoriesFilter,
        subCatFilter: action.subCatFilter
      });
    case CHANGE_SUB_CAT:
      return (0, _extends3.default)({}, state, {
        categoriesFilter: action.categoriesFilter,
        subCatFilter: action.subCatFilter
      });
    case CHANGE_HEADER:
      return (0, _extends3.default)({}, state, {
        header: action.configHeader,
        configHeader: action.configHeader
      });
    case SET_REDIRECT_LOGIN:
      return (0, _extends3.default)({}, state, {
        pathname: action.pathname
      });
    case LOAD_DYNAMIC:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_DYNAMIC_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        appLink: action.result.appLink
      });
    case LOAD_DYNAMIC_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case SET_CATEGORY:
      return (0, _extends3.default)({}, state, {
        cat: action.cat
      });
    case BATCH_HOMEPAGE:
      return (0, _extends3.default)({}, state, {
        batchHomepage: {
          loading: true,
          data: [],
          fail: false
        }
      });
    case BATCH_HOMEPAGE_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          batchHomepage: {
            loading: false,
            fail: false,
            loaded: true
          }
        });
      }
    case BATCH_HOMEPAGE_FAIL:
      return (0, _extends3.default)({}, state, {
        batchHomepage: {
          loading: false,
          data: [],
          fail: true,
          loaded: true
        }
      });
    case SHOW_DOWNLOAD_APP_POPUP:
      return (0, _extends3.default)({}, state, {
        popupDownloadAppDisplayed: true
      });
    case HIDE_DOWNLOAD_APP_POPUP:
      return (0, _extends3.default)({}, state, {
        popupDownloadAppDisplayed: false
      });
    default:
      return state;
  }
}

function isBatchHomepageLoaded(globalState) {
  return globalState.setup && globalState.setup.batchHomepage.loaded;
}

function isLoaded(globalState) {
  return globalState.setup && globalState.setup.loaded;
}

function isSeoLoaded(globalState) {
  return globalState.setup && globalState.setup.seoLoaded;
}

function loadCat() {
  return {
    types: [LOAD_CAT, LOAD_CAT_SUCCESS, LOAD_CAT_FAIL],
    promise: function promise(client) {
      return client.get('/cat/load');
    }
  };
}
function loadSeo(pathSeo) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      var datas;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: LOAD_SEO,
                pathSeo: pathSeo
              });
              _context.next = 3;
              return _ApiServer.server.get('/seo/loadPage');

            case 3:
              datas = _context.sent;

              if (datas) {
                dispatch({
                  type: LOAD_SEO_SUCCESS,
                  payload: {
                    data: datas.data
                  }
                });
              } else {
                dispatch({
                  type: LOAD_SEO_FAIL
                });
              }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();

  // return {
  //   types: [LOAD_SEO, LOAD_SEO_SUCCESS, LOAD_SEO_FAIL],
  //   pathSeo,
  //   promise: () => server.get('/seo/loadPage')
  // };
}

function loadBanner() {
  return {
    types: [LOAD_BANNER, LOAD_BANNER_SUCCESS, LOAD_BANNER_FAIL],
    promise: function promise(client) {
      return client.get('/banner/loadAll');
    }
  };
}

function loadCatServer() {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
      var data;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch({
                type: LOAD_CAT
              });
              _context2.next = 3;
              return _ApiServer.server.get('/cat/load');

            case 3:
              data = _context2.sent;

              if (data) {
                dispatch({
                  type: LOAD_CAT_SUCCESS,
                  result: data
                });
              } else {
                dispatch({
                  type: LOAD_CAT_FAIL
                });
              }

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function (_x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function handleMainCat(categoriesFilter, subCatFilter) {
  return {
    type: CHANGE_MAIN_CAT,
    categoriesFilter: categoriesFilter,
    subCatFilter: subCatFilter
  };
}

function handleSubCat(subCatFilter, categoriesFilter) {
  return {
    type: CHANGE_SUB_CAT,
    categoriesFilter: categoriesFilter,
    subCatFilter: subCatFilter
  };
}

function changeHeader(page, options) {
  var configHeader = _support.Helper.getConfigHeader(page);
  if (options) {
    configHeader = (0, _extends3.default)({}, configHeader, options);
  }
  return {
    type: CHANGE_HEADER,
    configHeader: configHeader
  };
}

function setPathName(pathname) {
  return {
    type: SET_REDIRECT_LOGIN,
    pathname: pathname
  };
}

function loadDynamicLink(type, handle) {
  return {
    types: [LOAD_DYNAMIC, LOAD_DYNAMIC_SUCCESS, LOAD_DYNAMIC_FAIL],
    promise: function promise(client) {
      return client.get('/link/getDynamic?type=' + type + '&value=' + handle);
    }
  };
}

function batchInit(dispatch, types) {
  types.map(function (val) {
    return dispatch({
      type: val
    });
  });
}
function batchFail(dispatch, types) {
  types.map(function (val) {
    return dispatch({
      type: val,
      error: { message: 'Lỗi' }
    });
  });
}
function batchDispath(dispatch, typeSuccess, typeFail, data) {
  var response = data ? data.response : {};
  if (response.code === 200) {
    dispatch({
      type: typeSuccess,
      result: response.body
    });
  } else {
    dispatch({
      type: typeFail,
      error: response.body ? response.body : { message: 'Lỗi' }
    });
  }
}
function batchHomepage() {
  var _this3 = this;

  var body = [{
    method: 'GET',
    url: '/shop/load?page=1&pageSize=4&sort=prominent&sortTo=false&home=false&province=79'
  }, {
    method: 'GET',
    url: '/shop/load?page=1&pageSize=8&sort=nearby'
  }, {
    method: 'GET',
    url: '/shop/load?page=1&pageSize=4&sort=suggest&sortTo=false&province=79'
  }, {
    method: 'GET',
    url: '/collection/load?page=1&pageSize=12&sort=&sortTo=true&province=79'
  }, {
    method: 'GET',
    url: '/coupon/allVoucher'
  }, {
    method: 'GET',
    url: '/cat/load'
  }];
  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch) {
      var batchData;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // Init
              batchInit(dispatch, [PROMINENT, FEATURED, SUGGEST, COLLECTION, GET_ALL_REWARD, LOAD_CAT, BATCH_HOMEPAGE]);
              _context3.prev = 1;
              _context3.next = 4;
              return _ApiClient.client.post('/batch', {
                jsonData: { batch: body }
              });

            case 4:
              batchData = _context3.sent;

              batchDispath(dispatch, PROMINENT_SUCCESS, PROMINENT_FAIL, batchData[0]);
              batchDispath(dispatch, FEATURED_SUCCESS, FEATURED_FAIL, batchData[1]);
              batchDispath(dispatch, SUGGEST_SUCCESS, SUGGEST_FAIL, batchData[2]);
              batchDispath(dispatch, COLLECTION_SUCCESS, COLLECTION_FAIL, batchData[3]);
              batchDispath(dispatch, GET_ALL_REWARD_SUCCESS, GET_ALL_REWARD_FAIL, batchData[4]);
              batchDispath(dispatch, LOAD_CAT_SUCCESS, LOAD_CAT_FAIL, batchData[5]);
              _context3.next = 16;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3['catch'](1);

              batchFail(dispatch, [PROMINENT_FAIL, FEATURED_FAIL, SUGGEST_FAIL, COLLECTION_FAIL, GET_ALL_REWARD_FAIL, LOAD_CAT_FAIL]);

            case 16:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[1, 13]]);
    }));

    return function (_x5) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function setCat(cat) {
  return {
    type: SET_CATEGORY,
    cat: cat
  };
}

function showDownloadAppPopup() {
  return { type: SHOW_DOWNLOAD_APP_POPUP };
}

function hideDownloadAppPopup() {
  return { type: HIDE_DOWNLOAD_APP_POPUP };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/setup.js
// module id = 21
// module chunks = 0